import { router } from '@inertiajs/vue3';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

// @ts-expect-error Property 'Pusher' does not exist on type 'Window & typeof globalThis'.
window.Pusher = Pusher;

export const echo = new Echo({
    broadcaster: import.meta.env.VITE_BROADCAST_DRIVER ?? 'reverb',
    key: import.meta.env.VITE_REVERB_APP_KEY,
    wsHost: import.meta.env.VITE_REVERB_HOST,
    wsPort: import.meta.env.VITE_REVERB_PORT,
    wssPort: import.meta.env.VITE_REVERB_PORT,
    forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
    enabledTransports: ['ws', 'wss'],
});

router.on('before', (event) => {
    const socketId =  echo.socketId();

    if(socketId) {
        event.detail.visit.headers['X-Socket-Id'] = socketId;
    }
});